import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=525775ee&scoped=true&"
import script from "./PoweredBy.vue?vue&type=script&lang=js&"
export * from "./PoweredBy.vue?vue&type=script&lang=js&"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=525775ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525775ee",
  null
  
)

export default component.exports